<template>
  <div class="volunteer-apply-audit">
    <el-card class="full-card" :body-style="{ padding: '16px', height: '100%', display: 'flex', flexDirection: 'column' }">
      <div class="menu-box">
        <h2>志愿者认证审核</h2>
      </div>
      <div class="box-bd">
        <!-- 搜索栏 -->
        <el-form :inline="true" :model="searchForm" class="search-form">
          <el-form-item label="关键字">
            <el-input
              placeholder="姓名/手机号/身份证号/社区"
              v-model="searchForm.keyword"
              clearable
              style="width: 240px"
              @keyup.enter.native="handleSearch"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="handleSearch"
              ></el-button>
            </el-input>
          </el-form-item>
          <el-form-item label="审核状态">
            <el-select
              v-model="searchForm.status"
              placeholder="全部状态"
              clearable
              style="width: 140px"
            >
              <el-option label="待审核" value="pending"></el-option>
              <el-option label="已通过" value="passed"></el-option>
              <el-option label="已驳回" value="rejected"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleSearch"
              >搜索</el-button
            >
            <el-button icon="el-icon-refresh" @click="handleReset"
              >重置</el-button
            >
          </el-form-item>
        </el-form>

        <!-- 状态统计 -->
        <div class="stats-bar">
          <span>共 <b>{{ stats.total }}</b> 条申请</span>
          <el-tag class="stats-tag" size="small">
            <i class="el-icon-time"></i> 待审核 {{ stats.pending }}
          </el-tag>
          <el-tag class="stats-tag" size="small" type="success">
            <i class="el-icon-circle-check"></i> 已通过 {{ stats.passed }}
          </el-tag>
          <el-tag class="stats-tag" size="small" type="danger">
            <i class="el-icon-circle-close"></i> 已驳回 {{ stats.rejected }}
          </el-tag>
        </div>

        <!-- 表格 -->
        <el-table
          :data="tableData"
          height="100%"
          style="width: 100%; flex: 1; min-height: 0"
          v-loading="loading"
          border
          stripe
        >
          <el-table-column
            type="index"
            label="#"
            width="60"
            align="center"
          ></el-table-column>
          <el-table-column prop="real_name" label="姓名" width="110">
          </el-table-column>
          <el-table-column prop="id_card" label="身份证号" min-width="170" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="phone" label="手机号" width="130">
          </el-table-column>
          <el-table-column prop="community_name" label="所属社区" min-width="140" show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="审核状态" width="100" align="center">
            <template slot-scope="scope">
              <el-tag
                v-if="scope.row.status_key === 'pending'"
                type="warning"
                size="small"
                >待审核</el-tag
              >
              <el-tag
                v-else-if="scope.row.status_key === 'passed'"
                type="success"
                size="small"
                >已通过</el-tag
              >
              <el-tag
                v-else-if="scope.row.status_key === 'rejected'"
                type="danger"
                size="small"
                >已驳回</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column prop="apply_time" label="申请时间" width="160">
          </el-table-column>
          <el-table-column label="操作" width="200" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.status_key === 'pending'"
                size="mini"
                type="success"
                icon="el-icon-check"
                @click="handleApprove(scope.row)"
                >通过</el-button
              >
              <el-button
                v-if="scope.row.status_key === 'pending'"
                size="mini"
                type="danger"
                icon="el-icon-close"
                @click="handleReject(scope.row)"
                >驳回</el-button
              >
              <el-button
                size="mini"
                type="text"
                icon="el-icon-view"
                @click="handleDetail(scope.row)"
                >详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <el-pagination
          class="pagination"
          @current-change="handlePageChange"
          @size-change="handleSizeChange"
          :current-page="searchForm.page"
          :page-sizes="[10, 20, 50, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          :page-size="searchForm.limit"
          background
          :total="total"
        >
        </el-pagination>
      </div>
    </el-card>

    <!-- 详情对话框 -->
    <el-dialog
      title="志愿者认证申请详情"
      :visible.sync="detailDialogVisible"
      width="560px"
      :close-on-click-modal="false"
    >
      <el-descriptions :column="2" border>
        <el-descriptions-item label="姓名">
          {{ detailData.real_name || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="身份证号">
          {{ detailData.id_card || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="手机号">
          {{ detailData.phone || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="所属社区">
          {{ detailData.community_name || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="申请时间">
          {{ detailData.apply_time || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="审核时间">
          {{ detailData.audit_time || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="审核状态">
          <el-tag
            v-if="detailData.status_key === 'pending'"
            type="warning"
            size="small"
            >待审核</el-tag
          >
          <el-tag
            v-else-if="detailData.status_key === 'passed'"
            type="success"
            size="small"
            >已通过</el-tag
          >
          <el-tag
            v-else-if="detailData.status_key === 'rejected'"
            type="danger"
            size="small"
            >已驳回</el-tag
          >
        </el-descriptions-item>
        <el-descriptions-item
          v-if="detailData.status_key === 'rejected'"
          label="驳回原因"
          :span="2"
        >
          <span style="color: #f56c6c">{{ detailData.reject_reason }}</span>
        </el-descriptions-item>
      </el-descriptions>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'VolunteerApplyAudit',
  data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      stats: { total: 0, pending: 0, passed: 0, rejected: 0 },
      searchForm: {
        keyword: '',
        status: '',
        page: 1,
        limit: 20,
      },
      detailDialogVisible: false,
      detailData: {},
    }
  },
  methods: {
    // 列表查询
    async fetchList() {
      this.loading = true
      try {
        const { data: res } = await this.$axios.post(
          'admin/volunteer_apply/list',
          this.searchForm
        )
        if (res.code === 0 || res.code === 200) {
          this.tableData = res.data.list || []
          this.total = res.data.total || 0
          this.stats = res.data.stats || this.stats
        } else {
          this.$message.error(res.message || res.msg || '查询失败')
        }
      } catch (e) {
        this.$message.error('网络错误，请稍后重试')
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.searchForm.page = 1
      this.fetchList()
    },
    handleReset() {
      this.searchForm = { keyword: '', status: '', page: 1, limit: 20 }
      this.fetchList()
    },
    handlePageChange(page) {
      this.searchForm.page = page
      this.fetchList()
    },
    handleSizeChange(limit) {
      this.searchForm.limit = limit
      this.searchForm.page = 1
      this.fetchList()
    },
    handleApprove(row) {
      this.$confirm(`确认通过「${row.real_name}」的志愿者认证申请？`, '提示', {
        confirmButtonText: '确定通过',
        cancelButtonText: '取消',
        type: 'success',
      })
        .then(async () => {
          try {
            const { data: res } = await this.$axios.post(
              'admin/volunteer_apply/approve',
              { id: row.id }
            )
            if (res.code === 0 || res.code === 200) {
              this.$message.success('审核通过')
              this.fetchList()
            } else {
              this.$message.error(res.message || res.msg || '操作失败')
            }
          } catch (e) {
            this.$message.error('网络错误')
          }
        })
        .catch(() => {})
    },
    handleReject(row) {
      this.$prompt(
        `请输入驳回原因（申请人：${row.real_name}）`,
        '驳回申请',
        {
          confirmButtonText: '确定驳回',
          cancelButtonText: '取消',
          inputType: 'textarea',
          inputValidator: (value) => {
            if (!value || !value.trim()) return '请输入驳回原因'
            return true
          },
        }
      )
        .then(async ({ value }) => {
          try {
            const { data: res } = await this.$axios.post(
              'admin/volunteer_apply/reject',
              { id: row.id, reason: value.trim() }
            )
            if (res.code === 0 || res.code === 200) {
              this.$message.success('已驳回')
              this.fetchList()
            } else {
              this.$message.error(res.message || res.msg || '操作失败')
            }
          } catch (e) {
            this.$message.error('网络错误')
          }
        })
        .catch(() => {})
    },
    handleDetail(row) {
      this.detailData = row
      this.detailDialogVisible = true
    },
  },
  mounted() {
    this.fetchList()
  },
}
</script>

<style scoped>
.volunteer-apply-audit {
  height: calc(100vh - 150px);
  display: flex;
  flex-direction: column;
  min-height: 400px;
}
.full-card {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.full-card >>> .el-card__body {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 16px;
  overflow: hidden;
}
.menu-box h2 {
  margin: 0 0 12px 0;
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}
.box-bd {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  margin-top: 0;
}
.search-form {
  margin-bottom: 8px;
}
.stats-bar {
  margin-bottom: 8px;
  font-size: 14px;
  color: #606266;
  flex-shrink: 0;
}
.stats-bar b {
  color: #303133;
  font-size: 16px;
}
.stats-tag {
  margin-left: 10px;
}
.pagination {
  margin-top: 12px;
  text-align: right;
  flex-shrink: 0;
}
</style>
